import { NotificationChannelEnum } from '../enums/NotificationChannel.enum'

export class NotifiedUser {
	constructor(
		readonly name: string,
		readonly email: string,
		readonly phoneNumber: string,
		readonly farms: string[],
		readonly channels: NotificationChannelEnum[],
		readonly telegramChatId?: number,
		readonly id?: string,
	) {}
}
